import { gql } from "@apollo/client";

export const UserRegistrationListTotal = gql`
    query UserRegistrationListTotal {
        userRegistrationList {
            total
        }
    }
`;
